import { render } from "./ModalKyc.vue?vue&type=template&id=a98fb8dc&scoped=true"
import script from "./ModalKyc.vue?vue&type=script&lang=js"
export * from "./ModalKyc.vue?vue&type=script&lang=js"

import "./ModalKyc.vue?vue&type=style&index=0&id=a98fb8dc&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a98fb8dc"]])

export default __exports__